/**
 * branchConfig — конфиг сетки филиала из живых данных БД (AppData.branches).
 *
 * До V5 здесь был хардкод BRANCH_CONFIG на четыре прод-филиала (useGridData);
 * теперь единственный источник — таблица branches: экран EO-Конфигуратора,
 * правя tea_cutoff/shifting/tea_before, реально меняет поведение сетки DC.
 */

import { TEA_MIN_DEFAULT } from "@ub/shared";
import type { Branch } from "../api/types";

export interface BranchConfig {
  shifting?: boolean;
  teaBefore?: boolean;
  teaAfter?: boolean;
  teaCutoff?: string;
  teaMin?: number;
  /** 17.09: мастер-класс сдвигает следующие слоты на свою длительность. */
  mcShift?: boolean;
}

/**
 * Длительность чайной в минутах — ЕДИНСТВЕННЫЙ не-БД остаток конфига:
 * колонки в branches нет (per-booking значение живёт в bookings.tea_minutes),
 * поэтому дефолт объявлен один раз — с 04.10 в @ub/shared/teaSpan: им же лишняя
 * чайная сдвигает сетку в гейте, публичных слотах и расписании «Мира Квестов».
 */
export { TEA_MIN_DEFAULT };

/** D1-приведение: boolean-колонки приходят как 1/0 — приводим к честному boolean. */
const d1Bool = (v: boolean | number | undefined): boolean | undefined =>
  v == null ? undefined : !!v;

/**
 * Конфиг филиала по id. Филиала нет в кеше → {}: потребители применяют
 * прежние безопасные дефолты (shifting=false, чайных нет, cutoff «19:00»,
 * TEA_MIN_DEFAULT минут) — не падаем.
 */
export function getBranchConfig(branches: Branch[], branchId: string): BranchConfig {
  const b = branches.find((x) => x.id === branchId);
  if (!b) return {};
  return {
    shifting: d1Bool(b.shifting),
    mcShift: d1Bool(b.mc_shift),
    teaBefore: d1Bool(b.tea_before),
    teaAfter: d1Bool(b.tea_after),
    teaCutoff: b.tea_cutoff,
    teaMin: TEA_MIN_DEFAULT,
  };
}
